<template>
  <div>
    <QS-scroller-box v-loading="boxLoading">
      <QS-h3-title :title="title" />
      <QS-h4-title title="基本信息" />

      <form-text-box
        ref="storeInfoBox"
        :dataList="storeInfo_formConfig"
        :rules="storeInfo_formRule"
        :model="storeInfo_model"
        :column="2"
      />
      <div v-if="title === '编辑门店'">
        <QS-h4-title title="集团侧上架的租赁方案" />
        <QS-common-table :data="list" :columns="columns" :pagination="false" />
      </div>
      <template slot="bottomAction">
        <el-button size="mini" @click="handleCancelFn">取消</el-button>
        <el-button
          :loading="submitLoading"
          size="mini"
          @click="handleSubmitFn"
          type="primary"
        >确认</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import addDataConfig from '../config/add'
import { addrList, areaList, provinceCityList } from '@/api/global'
import { storeSave, storeDetail } from '@/api/domain/shop'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  name: 'addStore',
  data() {
    const {
      storeInfo_formConfig,
      storeInfo_formRule,
      storeInfo_model,
      columns,
    } = addDataConfig.call(this)
    return {
      storeInfo_formConfig,
      storeInfo_formRule,
      storeInfo_model,
      columns,
      list: [],
      submitLoading: false,
      boxLoading: false,
      cacheStoreAddressInfo: {
        // 上一次门店数据
        cityCode: null,
        longitude: null,
        latitude: null,
        address: null,
      },
    }
  },
  computed: {
    title() {
      return this.$route.query.id ? '编辑门店' : '新增门店'
    },
  },
  watch: {
    // 省份
    'storeInfo_model.provinceCode': {
      handler(val) {
        if (val) {
          this.getCityList(val) // 查询城市
        } else {
          // 清空已选城市
          this.$set(this.storeInfo_model, 'cityCode', '')
          // 清空已选地址
          this.$set(this.storeInfo_model, 'address', '')
          // 所选省份清空后，禁用城市和地址
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'disabled',
            key: 'cityCode',
            data: true,
          })
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'disabled',
            key: 'address',
            data: true,
          })
        }
      },
    },
    'storeInfo_model.cityCode': {
      handler(val) {
        if (val) {
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'disabled',
            key: 'address',
            data: false,
          })
          this.storeInfo_model.cityCode = val
        } else {
          this.$set(this.storeInfo_model, 'address', '')
          // 所选城市清空后，禁用地址选项
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'disabled',
            key: 'address',
            data: true,
          })
          // 所选城市清空后，设置所选地址列清空
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'list',
            key: 'address',
            data: [],
          })
        }
      },
    },
  },
  created() {
    // 获取省份
    this.getAreaList()
    const { id } = this.$route.query
    id && this.queryDetailData(id)
  },
  methods: {
    // 获取详情数据
    async queryDetailData(id) {
      this.boxLoading = true
      const { code, data } = await storeDetail({ id })
      this.boxLoading = false
      if (code === 1) {
        // 租赁方案
        this.list = data.rentPlans || []
        const storeVO = data.storeVO || {}
        const needLicenseType = data.needLicenseType || [10, 20, 30]
        const { address: theAddress, longitude, latitude, name, contactTel, provinceCode, cityCode, contactQRCode } = storeVO
        const address = theAddress || ''
        const location = [longitude, latitude].toString()
        // 基本信息反显
        this.storeInfo_model.name = name || ''
        this.storeInfo_model.contactTel = contactTel || ''
        this.storeInfo_model.provinceCode = provinceCode || ''
        this.storeInfo_model.cityCode = cityCode || ''
        this.storeInfo_model.needLicenseType = needLicenseType
        this.$refs.storeInfoBox.setItemData({
          elConfigKey: 'fileList',
          key: 'contactQRCode',
          data: this.getEchoUploadFileData(contactQRCode, true),
        })

        // 设置地址
        this.$refs.storeInfoBox.setItemData({
          elConfigKey: 'list',
          key: 'address',
          data: [{ address, location, district: '' }],
        })
        this.storeInfo_model.address = location

        if (storeVO.provinceCode) {
          // 根据接口返回省份，请求城市列表
          this.getCityList(storeVO.provinceCode)
          this.$refs.storeInfoBox.setItemData({
            elConfigKey: 'disabled',
            key: 'cityCode',
            data: false,
          })
        }

        // 缓存门店地址相关信息
        this.cacheStoreAddressInfo.cityCode = storeVO.cityCode
        this.cacheStoreAddressInfo.longitude = storeVO.longitude
        this.cacheStoreAddressInfo.latitude = storeVO.latitude
        this.cacheStoreAddressInfo.address = storeVO.address
      }
    },
    // 省份选择 addDataConfig中有引用
    // eslint-disable-next-line vue/no-unused-properties
    handleProvince() {
      this.$refs.storeInfoBox.setItemData({
        elConfigKey: 'disabled',
        key: 'cityCode',
        data: false,
      })
    },
    // 取消
    handleCancelFn() {
      this.$refreshBack(false) // 关闭当前tab
    },
    // 获取店铺地址接口 addDataConfig中有引用
    // eslint-disable-next-line vue/no-unused-properties
    async getStoreList(keywords) {
      keywords = keywords.trim()
      // 开启远程搜索
      const { code, data } = await addrList({
        keywords,
        adcode: this.storeInfo_model.cityCode,
      })
      if (code === 1) {
        // 设置可选地址list
        this.$refs.storeInfoBox.setItemData({
          elConfigKey: 'list',
          key: 'address',
          data: data || [],
        })
      }
    },
    validFormData() {
      return new Promise((resolve) => {
        this.$refs.storeInfoBox.getRefs().validate((validate) => {
          resolve(validate)
        })
      })
    },
    // 确定提交
    async handleSubmitFn() {
      let validateFlag = false
      // 经纬度
      const longitude = this.storeInfo_model.address.split(',')[0] || ''
      const latitude = this.storeInfo_model.address.split(',')[1] || ''
      // 店铺名称，联系电话，省份，城市，具体地址（这里绑定的是经纬度字符串）
      const {
        name,
        contactTel,
        provinceCode,
        cityCode,
        address,
      } = this.storeInfo_model
      // 根据经纬度，找出实际地址的中文
      const someAddressConfigItem = this.storeInfo_formConfig.find(
        (item) => item.itemConfig.prop === 'address',
      ) // 先找到地址对象的选项list
      const addressItem =
        someAddressConfigItem.elConfig.options.list.find(
          (item) => item.location === address,
        ) || '' // 再找到所选地址
      const addressName = addressItem ? addressItem.address : ''
      const params = {
        name,
        contactTel,
        address: addressName,
        cityCode,
        provinceCode,
        longitude,
        latitude,
        needLicenseType: this.storeInfo_model.needLicenseType,
      }
      if (this.$route.query.id) {
        params.id = this.$route.query.id
      }
      const qrCode = this.storeInfo_formConfig.find((item) => item.itemConfig.prop === 'contactQRCode')
      params.contactQRCode = this.getUoloadCommonFileData(qrCode.elConfig.fileList)
      if (!addressName) {
        this.storeInfo_model.address = ''
      }
      validateFlag = await this.validFormData()
      if (!validateFlag) return false
      if (
        this.$route.query.id &&
        (params.address !== this.cacheStoreAddressInfo.address ||
          Number(params.cityCode) !==
            Number(this.cacheStoreAddressInfo.cityCode))
      ) {
        this.$confirm(
          '门店地址修改后，租车商城下单用户可能无法找到最新的门店地址，建议修改后及时告知下单用户。',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.submitData(params)
        }).catch(() => null)
      } else {
        this.submitData(params)
      }
    },
    async submitData(params) {
      this.submitLoading = true
      const { code, data } = await storeSave(params).catch(() => {
        this.submitLoading = false
      })
      this.submitLoading = false
      if (code === 1) {
        this.$message.success(
          `门店${this.$route.query.id ? '编辑' : '添加'}成功`,
        )
        // 商品管理页面跨页面通信 通知门店信息刷新
        if (this.$route.query.scene === '1') {
          const communication = new WindowCommunication('lease_store_added')
          communication.send(true)
          // 关闭window
          window.close()
          return
        }
        // 签约提车页面跨页面通信 刷新签约提车页面门店列表
        if (this.$route.query.scene === '2') {
          const signCommunication = new WindowCommunication('person_sign_contract')
          signCommunication.send({
            type: 'add_store',
            data, // 门店id
          })
          // 关闭window
          window.close()
          return
        }
        this.$router.back()
        this.$refreshBack(true) // 关闭当前tab
      }
    },
    // 获取省
    async getAreaList() {
      const { code, data } = await areaList({ level: 1 })
      if (code !== 1) return
      // 设置省份可选项
      this.$refs.storeInfoBox.setItemData({
        elConfigKey: 'list',
        key: 'provinceCode',
        data: data || [],
      })
    },
    // 根据省份查询城市
    async getCityList(provinceCode) {
      if (!provinceCode) return
      this.$refs.storeInfoBox.setItemData({
        elConfigKey: 'loading',
        key: 'cityCode',
        data: true,
      })
      const { code, data } = await provinceCityList({ provinceCode })
      this.$refs.storeInfoBox.setItemData({
        elConfigKey: 'loading',
        key: 'cityCode',
        data: false,
      })
      if (code === 1) {
        // 判断当前省份列表中是否有当前已选城市，没有，则清空已选城市
        const ct = data.find(
          (item) =>
            Number(item.cityCode) === Number(this.storeInfo_model.cityCode),
        )
        !ct && this.$set(this.storeInfo_model, 'cityCode', '')

        // 判断当前地址列表中是否有当前已选地址，没有，则清空已选地址
        const elItem =
          this.storeInfo_formConfig.find(
            (item) => item.itemConfig.prop === 'address',
          ) || {}
        const elItemOptionItem = elItem?.elConfig?.options?.list?.find(
          (item) => item.location === this.storeInfo_model.address,
        )
        !elItemOptionItem && this.$set(this.storeInfo_model, 'address', '')

        // 设置城市可选项
        this.$refs.storeInfoBox.setItemData({
          elConfigKey: 'list',
          key: 'cityCode',
          data: data || [],
        })
      }
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-form-item__error {
  position: initial;
}
</style>
